import { some } from '@utils/some';
import { ConfigurationGroupOptionType, ConfigurationGroupType } from 'shared-types/SpaPackage';

export const isSpaPackageUnavailable = (
  configGroups: ConfigurationGroupType[],
  numberOfGuests: number
): boolean => {
  const configGroupsWithoutExtras = configGroups.filter((group) =>
    group.options.every((option) => option.type !== 'spa-extras')
  );

  return some(configGroupsWithoutExtras, (group) => {
    if (!group.options?.length) return false;

    const filteredOptions = group.options.filter(
      (option) => option.type && !option.type.includes('extra')
    );

    // If maximumSelections is not defined, we need to check if there are enough options for the number of guests
    if (group.maximumSelections === undefined) {
      return filteredOptions.every((option) => getGroupAvailability(option) < numberOfGuests);
    } else {
      // If maximumSelections is defined, check if there are enough available options
      const optionsWithAvailability = filteredOptions.filter(
        (option) => getGroupAvailability(option) >= numberOfGuests
      );

      return optionsWithAvailability.length < group.maximumSelections;
    }
  });
};

const getGroupAvailability = (option: ConfigurationGroupOptionType): number => {
  if (!option.timeslots?.length) return 0;
  return option.timeslots.reduce((total, timeslot) => {
    return total + (timeslot.quantity || 1);
  }, 0);
};
